import { axios } from '@/utils/request'
import {mockRepaymentReport, useMock} from "@/api/_mock";

export function getFinancialList (parameter = {}) {
  return axios({
    url: '/statistics/financialListNew',
    method: 'post',
    data: parameter
  })
}
export function getOrderLoanStatisticsList (parameter = {}) {
  return axios({
    url: '/statistics/orderLoanStatisticsList',
    method: 'post',
    data: parameter
  })
}

export function getPvList (parameter = {}) {
  return axios({
    url: '/statistics/pvList',
    method: 'post',
    data: parameter
  })
}

export function getUvList (parameter = {}) {
  return axios({
    url: '/statistics/uvList',
    method: 'post',
    data: parameter
  })
}

export function getDayTotal (parameter = {}) {
  return axios({
    url: '/statistics/total/list',
    method: 'post',
    data: parameter
  })
}

export function groupApplyProductByDate (parameter = {}) {
  return axios({
    url: '/statistics/total/groupApplyProductByDate',
    method: 'post',
    data: parameter
  })
}

export function listOrderNumByMobile (parameter = {}) {
  return axios({
    url: '/statistics/total/listOrderNumByMobile',
    method: 'post',
    data: parameter
  })
}